import Map from "./Map";

function LocationHours() {
	return (
		<div className="mb-location-hours">
			<div className="container">
				<Map />
				<div className="row mt-5">
					<div className="col-md-4 mb-3">
						<h4>Location & Hours</h4>
					</div>
					<div className="col-md-4 mb-3">
						<p>
							2828 Kingsway Dr, Unit 3<br />
							Oakville, ON L6J 7M2
							<br />
							<a href="tel:905-287-0036">(905) 287-0036</a>
							<br />
							<a href="mailto:maneandbare@gmail.com">maneandbare@gmail.com</a>
							<br />
							<a
								href="https://www.google.com/maps/dir/?api=1&destination=2828+Kingsway+Drive+Oakville+ON+L6J+7M2"
								target="_blank"
								rel="noreferrer"
							>
								Get directions
							</a>
						</p>
					</div>
					<div className="col-md-4 mb-3">
						<p>
							Mon-Sat: Open - By Appointment
							<br />
							Sun: Closed
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default LocationHours;
